/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { ScheduleTemplatesFinderBusinessService } from '../../resources/schedule-template-finder-business.service';

import { ScheduleTemplateFinderDialogComponent } from './schedule-template-finder-dialog.component';

export const scheduleTemplateFinderDialogRoute = createDialogRoute({
  component: ScheduleTemplateFinderDialogComponent,
  init: ScheduleTemplatesFinderBusinessService,
});
